export const SUPPLEMENTAL_CATEGORIES = [
  { name: 'industries' },
];
